import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import '../styles/Blog.css';

const Blog = () => {
  const posts = [
    {
      id: 1,
      title: '10 Best Practices for Building Scalable Web Applications',
      excerpt: 'Learn the key principles and patterns for building web applications that can handle growth.',
      category: 'Development',
      date: 'Jan 15, 2025',
      readTime: '8 min read',
      image: 'https://images.unsplash.com/photo-1630283017802-785b7aff9aac?w=800'
    },
    {
      id: 2,
      title: 'The Complete Guide to Mobile App Development in 2025',
      excerpt: 'Everything you need to know about building modern mobile applications for iOS and Android.',
      category: 'Mobile',
      date: 'Jan 10, 2025',
      readTime: '12 min read',
      image: 'https://images.pexels.com/photos/8947493/pexels-photo-8947493.jpeg'
    },
    {
      id: 3,
      title: 'SEO Strategies That Actually Work in 2025',
      excerpt: 'Proven SEO techniques to improve your organic traffic and search rankings.',
      category: 'SEO',
      date: 'Jan 5, 2025',
      readTime: '10 min read',
      image: 'https://images.unsplash.com/photo-1703355685639-d558d1b0f63e?w=800'
    }
  ];

  return (
    <div className="blog-page" data-testid="blog-page">
      <Navbar />
      
      <section className="blog-hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1 className="page-title" data-testid="blog-title">Blog & Insights</h1>
            <p className="page-subtitle" data-testid="blog-subtitle">
              Latest thoughts on product development, technology, and growth
            </p>
          </div>
        </div>
      </section>

      <section className="blog-content">
        <div className="container">
          <div className="blog-grid">
            {posts.map((post) => (
              <article className="blog-card card" key={post.id} data-testid={`blog-post-${post.id}`}>
                <div className="blog-image">
                  <img src={post.image} alt={post.title} />
                  <div className="blog-category">{post.category}</div>
                </div>
                <div className="blog-info">
                  <h2>{post.title}</h2>
                  <p>{post.excerpt}</p>
                  <div className="blog-meta">
                    <span className="meta-item">
                      <Calendar size={16} />
                      {post.date}
                    </span>
                    <span className="meta-item">
                      <Clock size={16} />
                      {post.readTime}
                    </span>
                  </div>
                  <a href="#" className="read-more" data-testid={`read-more-${post.id}`}>
                    Read More
                    <ArrowRight size={18} />
                  </a>
                </div>
              </article>
            ))}
          </div>

          <div className="blog-empty-state">
            <p>More articles coming soon! Subscribe to our newsletter to stay updated.</p>
          </div>
        </div>
      </section>

    
    </div>
  );
};

export default Blog;